import React from 'react';

const TaglineBar = () => (
  <div className="px-4 flex items-center min-h-[2.75rem] border-t border-b border-black">
    <p className="text-lg text-black">Designed for, Focused on and Targeting Online Scammers</p>
  </div>
);

export default TaglineBar;
